import React from 'react';
import InfoPage from './InfoPage';

const TermsPage = () => {
  return <InfoPage type="terms" />;
};

export default TermsPage;
